/*========================================
        Imports!!!
=========================================*/

/*--BrowserRouter and react components--*/

import { Link, useNavigate, generatePath } from 'react-router-dom';
import { useEffect, useState } from 'react';

/*--css--*/
import '../assets/css/blog.css';
import '../assets/css/staticElements.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


/*--cows footer--*/

import mu1 from '../assets/cowsss/lower/3.webp';
import mu2 from '../assets/cowsss/lower/5.webp';
import mu3 from '../assets/cowsss/lower/6.webp';
import mu4 from '../assets/cowsss/lower/7.webp';
import mu5 from '../assets/cowsss/lower/4.webp';
import mu6 from '../assets/cowsss/lower/1.webp';
import social2 from '../assets/icons/phone.webp';
import social3 from '../assets/icons/insta.webp';


/*--image shorts--*/

import short1 from '../assets/shortsImg/lower/1.webp';
import short2 from '../assets/shortsImg/lower/2.webp';
import short3 from '../assets/shortsImg/lower/3.webp';
import short4 from '../assets/shortsImg/lower/4.webp';
import short5 from '../assets/shortsImg/lower/5.webp';
import short6 from '../assets/shortsImg/lower/6.webp';

/*--logo--*/
import logo from '../assets/img/logo.webp';

/*--high--*/

/*--cows footer--*/

import mu1h from '../assets/cowsss/higher/3.webp';
import mu2h from '../assets/cowsss/higher/5.webp';
import mu3h from '../assets/cowsss/higher/6.webp';
import mu4h from '../assets/cowsss/higher/7.webp';
import mu5h from '../assets/cowsss/higher/4.webp';
import mu6h from '../assets/cowsss/higher/1.webp';
/*--image shorts--*/
import short1h from '../assets/shortsImg/higher/1.webp';
import short2h from '../assets/shortsImg/higher/2.webp';
import short3h from '../assets/shortsImg/higher/3.webp';
import short4h from '../assets/shortsImg/higher/4.webp';
import short5h from '../assets/shortsImg/higher/5.webp';
import short6h from '../assets/shortsImg/higher/6.webp';

/*========================================
        Functions!!!
=========================================*/

function LinkToContact() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/');
    navigate('/#Contact');
  };

  return (
    <button onClick={handleClick}>O nas</button>
  );
}

function LinkToProducts() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/');
    navigate('/#Products');
  };

  return (
    <button onClick={handleClick}>Produkty</button>
  );
}

/*========================================
        Buttons and navigation!!!
=========================================*/


function ClickButton({ onSelect, Changing7 }) {
  return (
    <>
      <section className='Buttonsy'>
        {/*--button--*/}
        <button onClick={() => onSelect(1)}  reloaddocument ="true" id="szorcik1">
          <Row className='Post'>
            <Col lg={4} md={6} xs={12}>
              <img onLoad={Changing7} src={short1} alt='krowy' className='ZdjWPoscie' id="short1"/>
            </Col>
            <Col lg={8} md={6} xs={12} className='postText'>
              <h3>Przywitajmy nowego członka rodziny!</h3>
              <p>W naszym stadzie pojawiło się nowe życie! Zgadniecie, kto właśnie do nas dołączył?</p>
            </Col>
          </Row>
        </button>
        {/*--button--*/}
        <button onClick={() => onSelect(2)} reloaddocument ="true" id="szorcik2">
          <Row className='Post'>
            <Col lg={4} md={6} xs={12}>
              <img onLoad={Changing7} src={short2} alt='krowy' className='ZdjWPoscie' id="short2"/>
            </Col>
            <Col lg={8} md={6} xs={12} className='postText'>
              <h3>Naturalne źródło wody</h3>
              <p>Nie każda hodowla może pochwalić się takim skarbem! Zajrzyjcie, co płynie przez samo serce naszego pastwiska.</p>
            </Col>
          </Row>
        </button>
        {/*--button--*/}
        <button onClick={() => onSelect(3)} reloaddocument ="true">
          <Row className='Post'>
            <Col lg={4} md={6} xs={12}>
              <img onLoad={Changing7} src={short3} alt='krowy' className='ZdjWPoscie' id="short3"/>
            </Col>
            <Col lg={8} md={6} xs={12} className='postText'>
              <h3>Nasi cisi pomocnicy</h3>
              <p>Kto naprawdę rządzi przy zaganianiu krów? Te psy mają talent i serce do pracy!</p>
            </Col>
          </Row>
        </button>
        {/*--button--*/}
        <button onClick={() => onSelect(4)} reloaddocument ="true">
          <Row className='Post'>
            <Col lg={4} md={6} xs={12}>
              <img onLoad={Changing7} src={short4} alt='krowy' className='ZdjWPoscie' id="short4"/>
            </Col>
            <Col lg={8} md={6} xs={12} className='postText'>
              <h3>Sesja zdjęciowa w naszym stadzie</h3>
              <p>Kudłate modelki, naturalna sceneria i aparat w gotowości. Zobaczcie efekty naszej pastwiskowej sesji!</p>
            </Col>
          </Row>
        </button>
        {/*--button--*/}
        <button onClick={() => onSelect(5)} reloaddocument ="true">
          <Row className='Post'>
            <Col lg={4} md={6} xs={12}>
              <img onLoad={Changing7} src={short5} alt='krowy' className='ZdjWPoscie' id="short5"/>
            </Col>
            <Col lg={8} md={6} xs={12} className='postText'>
              <h3>Jaką paszę dawać krowom?</h3>
              <p>Nie wszystko, co zielone, to dobra dieta! Sprawdź, co naprawdę jedzą nasze Highlandy.</p>
            </Col>
          </Row>
        </button>
        {/*--button--*/}
        <button onClick={() => onSelect(6)} reloaddocument ="true">
          <Row className='Post'>
            <Col lg={4} md={6} xs={12}>
              <img onLoad={Changing7} src={short6} alt='krowy' className='ZdjWPoscie' id="short6"/>
            </Col>
            <Col lg={8} md={6} xs={12} className='postText'>
              <h3>Nowy dżentelmen w stadzie</h3>
              <p>Przystojny, silny i z imponującymi rogami nasz nowy byk właśnie dołączył do Beskidzkiego Stada!</p>
            </Col>
          </Row>
        </button>
      </section>
    </>
  );

}


function Send() {
  const navigate = useNavigate();
  const [selectedNumber, setSelected] = useState(null);

  useEffect(() => {
    if (selectedNumber !== null) {
      const path = generatePath("/story/:id", { id: selectedNumber });
      navigate(path);
    }
    
  },[selectedNumber, navigate])

  return (
    <>
      <section className='send'>
        <section className='posts'>
          <ClickButton onSelect={setSelected}/>
        </section>
      </section>
    </>
  );

}


/*========================================
        Header!!!
=========================================*/

function Header(){
  return (
    <>
    {/*====Header====*/}
    <header>
      <Row className='p-4'>
        {/*----Logo----*/}
        <Col xl={8} lg={7} md={6}>
          <div className='Logo'>
              <Link to="/" reloaddocument ="true">
                <Row>
                  <Col lg={1} md={2} xs={2} className='log'>
                    <img src={logo} alt='logo' />
                  </Col>
                  <Col  lg={10} md={9} xs={9} className='log textlog'>
                    Beskidzkie Stado
                  </Col>
                </Row>
              </Link>
          </div>
        </Col>
        {/*----Tabs----*/}
        <Col xl={4} lg={5} md={6} className='log'>
          <Row className='Tabs'>
            <Col lg={3} md={3} xs={3} className='Tcol'>
              <a href='#About' >
                <LinkToContact />
              </a>
            </Col>
            <Col lg={3} md={3} xs={3} className='Tcol'>
              <a href='#Products'>
                <LinkToProducts />
              </a>
            </Col>
            <Col lg={3} md={3} xs={3} className='Tcol'>
              <a href='#Contact'>
                <button>Kontakt</button>
              </a>
            </Col>
            <Col lg={3} md={3} xs={3} className='Tcol'>
                <Link to="/blog" reloaddocument ="true">
                  <button>Blog</button>
                </Link>
            </Col>
          </Row>
        </Col>
      </Row>
      </header >
    </>
  );
}

/*========------------========*/
/*========------------========*/
/*------Footer------*/
/*========------------========*/
/*========------------========*/

function Footer({Changing7}) {
  return (
    <>
      <section className='footer'>
        <Row className='MiniGallery'>
          {/*-short gallery-*/}
          <Col lg={6} md={12} xs={12} className='mincol'>
            <section className='stadko'>
              {/*-logo-*/}
              <div className='FooterLogo'>
                <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                  <Row>
                    <Col lg={2} md={1} xs={2} className='logoFooter'>
                      <p>
                        <img src={logo} alt='logo' />
                      </p>
                    </Col>
                    <Col lg={10} md={11} xs={10} className='logoFooter'>
                      <h2>Beskidzkie Stado</h2>
                    </Col>
                  </Row>
                </a>
              </div>
              {/*-photos-*/}
              <div className='smallGallery'>
                <Row>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing7} src={mu6} alt="Cow" id="mu6"/>
                    </a>  
                  </Col>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing7} src={mu4} alt="Cow" id="mu4"/>
                    </a>
                  </Col>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing7} src={mu3} alt="Cow" id="mu3"/>
                    </a>
                  </Col>
                </Row>
                <Row className='tooff'>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing7} src={mu2} alt="Cow" id="mu2"/>
                    </a>
                  </Col>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing7} src={mu5} alt="Cow" id="mu5"/>
                    </a>
                  </Col>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing7} src={mu1} alt="Cow" id="mu1"/>
                    </a>
                  </Col>
                </Row>
              </div>
            </section>
          </Col>
          {/*-Contact-*/}
          <Col lg={6} md={12} xs={12}  className='mincol'>
              <section className='contact' id='Contact'>
                <div>
                  <h2>Kontakt</h2>
                </div>
                <section className='links'>
                  {/*-phone-*/}
                  <Row className='package'>
                    <Col lg={2} md={12} xs={12} className='Colek'>
                      <a href='tel:+48 532 233 916'>
                        <img src={social2} alt="socialek" loading="lazy" />
                      </a>
                    </Col>
                    <Col lg={9} md={12} xs={12} className='Colek'>
                      <span>+48 532 233 916</span>
                    </Col>
                  </Row>
                  {/*-instagram-*/}
                  <Row className='package'>
                    <Col lg={2} md={12} xs={12} className='Colek'>
                      <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                        <img src={social3} alt="socialek" loading="lazy" />
                      </a>
                    </Col>
                    <Col lg={9} md={12} xs={12} className='Colek'>
                      <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                        <span>Beskidzkie_stado</span>
                      </a>
                    </Col>
                  </Row>
                </section>
            </section>
          </Col>
        </Row>
        {/*-Copyright-*/}
        <Row>
          <Col lg={12} md={12} xs={12} className='copyright'>
            <div className='copya'>All rights reserved. Created by <a href="https://pixelpick.pl"> PixelPick</a></div>
          </Col>
        </Row>
      </section>
    </>
  );
}



function Blog() {
  const [loadedCount7, setLoadedCount7] = useState(null);

  const Changing7 = () => {
    setLoadedCount7(prev => {
      const NewCount7 = prev + 1;
      console.log(NewCount7);
      if (NewCount7 === 6) {
        setTimeout(() => {
          console.log("Iaam loading better quality photos now");
  
          const safeSetSrc = (id, src) => {
            const el = document.getElementById(id);
            if (el) el.src = src;
            else console.warn(`Element ${id} nie znaleziony.`);
          };
  
          safeSetSrc("short1", short1h);
          safeSetSrc("short2", short2h);
          safeSetSrc("short3", short3h);
          safeSetSrc("short4", short4h);
          safeSetSrc("short5", short5h);
          safeSetSrc("short6", short6h);
          safeSetSrc("mu1", mu1h);
          safeSetSrc("mu2", mu2h);
          safeSetSrc("mu3", mu3h);
          safeSetSrc("mu4", mu4h);
          safeSetSrc("mu5", mu5h);
          safeSetSrc("mu6", mu6h);
  
        }, 2000);
        console.log(loadedCount7);
      }
      return NewCount7;
    });
  }

    return (
      <>  
        <Header />
        <Send Changing7={Changing7}/>
        <Footer Changing7={Changing7}/>
      </>
    );
}

export default Blog;